import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
    Product,
    ProductAttribute,
    ProductAttributeGroup,
    ProductCompatibilityResult
} from '../../../../interfaces/product';
import { ProductGalleryLayout } from '../../../shared/components/product-gallery/product-gallery.component';
import { UrlService } from '../../../../services/url.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { finalize, map, switchMap, takeUntil } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import { Breadcrumb } from '../../../shared/components/block-header/block-header.component';
import { ApiService } from '../../../../service/api.service';
import { ToastrService } from 'ngx-toastr';

export type PageProductLayout = 'sidebar' | 'full';

export type PageProductSidebarPosition = 'start' | 'end';

export interface PageProductData {
    layout: PageProductLayout;
    sidebarPosition: PageProductSidebarPosition;
    product: Product;
}

@Component({
    selector: 'app-page-product',
    templateUrl: './page-product.component.html',
    styleUrls: ['./page-product.component.scss'],
})
export class PageProductComponent implements OnInit {
    private destroy$: Subject<void> = new Subject<void>();

    layout: PageProductLayout = 'sidebar';

    sidebarPosition: PageProductSidebarPosition = 'start';

    breadcrumb$: Observable<Breadcrumb[]>;


    product: Product;

    data : any;
    form: FormGroup;
    enquiryForm: FormGroup;

    addToCartInProgress = false;
    slug : string = this.route.snapshot.paramMap.get('productSlug');
    @ViewChild('tabs', {read: ElementRef}) tabsElementRef: ElementRef;

    get tabsElement(): HTMLElement {
        return this.tabsElementRef.nativeElement;
    }

    get galleryLayout(): ProductGalleryLayout {
        return `product-${this.layout}` as ProductGalleryLayout;
    }


    constructor(
        private fb: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private translate: TranslateService,
        public url: UrlService,
        private toastr: ToastrService,

        private service : ApiService
    ) { }
    newData:any;

    ngOnInit(): void {
        this.layout = "full"
        this.sidebarPosition = "start"
        this.loadData(this.slug);


        this.newData = [
                    {label: this.translate.instant('LINK_HOME'), url: '/'},
                ]



        this.enquiryForm = this.fb.group({
            name: ['', [Validators.required]],
            email : ['', [Validators.required]],
            phone_no : ['', [Validators.required]],
            message: ['', [Validators.required]],
        })
    }

        submitForm(id){
            if(this.enquiryForm.valid){
                console.log(this.enquiryForm.value)
                let data = {
                    "name" : this.enquiryForm.value.name,
                    "email" : this.enquiryForm.value.email,
                    "phone_no" : this.enquiryForm.value.phone_no,
                    "message" : this.enquiryForm.value.message,
                    "university" : this.data.id
                }
                this.service.postUniversityForm(data).subscribe((res:any) => {
                    console.log(res)
                    this.enquiryForm.reset();
                    this.toastr.success("Enquiry Sended Successfully.", "" , {timeOut: 6000});

                })
            }else{
                this.toastr.error("All Fields are required.", "" , {timeOut: 6000});

            }

        }

    loadData(slug){
        this.service.getUniversityBySlug(slug).subscribe((res:any) =>{
            res.newImage = []
            res.cover_image= [res.cover_image]
            console.log("new res",res.galleries_set.forEach(myFunction))
            this.data = res;
            function myFunction(data, index) {

                console.log("data",data.image, index)
                res.newImage[index] = data.image
                console.log(res)
            }

        })

    }




    scrollToTabs(): void {
        this.tabsElement.scrollIntoView({behavior: 'smooth'});
    }

}
